import { render } from "./GenreNew.vue?vue&type=template&id=2680b04d"
import script from "./GenreNew.vue?vue&type=script&lang=js"
export * from "./GenreNew.vue?vue&type=script&lang=js"
script.render = render

export default script